
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import { FACT_FILE_INDEX } from '@constants/routes';
import { FILTER_CATEGORIES_DATA } from '@constants/index';
import { trackClickEvent } from '@utils/analytics';
import RenderAnimation from '@components/RenderAnimation';
import AnchorLink from '@components/AnchorLink';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './Badge.module.scss';
const propTypes = {
    category: PropTypes.string.isRequired,
    analyticsParams: PropTypes.shape({}).isRequired
};
const Badge = ({ category, analyticsParams }) => {
    const [hover, setHover] = useState(false);
    const [animationData, setAnimationData] = useState(null);
    const categoryName = FILTER_CATEGORIES_DATA.find((filter) => filter.slug === category)?.name;
    useEffect(() => {
        // Get the animation based on category
        const getAnimation = async () => {
            const animation = await import(`../../../../animations/factfile_${category}.json`);
            setAnimationData(animation);
        };
        getAnimation();
    }, [category]);
    const handleClick = () => {
        trackClickEvent({
            destination_url: `${FACT_FILE_INDEX}/${category}`,
            label: 'Fact File Category Badge',
            location: 'Badge',
            vertical_index: 2,
            horizontal_index: 2,
            ...analyticsParams
        });
    };
    return (<AnchorLink className={s.root} href={`${FACT_FILE_INDEX}/${category}`} onMouseEnter={() => setHover(true)} onClick={handleClick}>
      <div className={cx(s.categoryBorder)}>
        {animationData && (<div className={s.content}>
            <RenderAnimation className={s.categoryIcon} ariaLabel="badge animation" animation="badge animation" animationData={animationData} isStopped={!hover} complete={() => setHover(false)} loop={false}/>
            <div className={s.categoryName}>{categoryName}</div>
          </div>)}
      </div>
    </AnchorLink>);
};
Badge.propTypes = propTypes;
export default Badge;

    async function __Next_Translate__getStaticProps__195ca0caf1d__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFile/components/Badge/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0caf1d__ as getStaticProps }
  